module.exports = __webpack_public_path__ + "img/gygx_09.df1a4f80.jpg";